module.exports = __webpack_public_path__ + "static/img/footer5.2bf76226.png";